import React from "react";
import PageLayout from "./PageLayout";
import ServicesSection from "./ServicesSection";
import PlansSection from "./PlansSection";
import PacksSection from "./PacksSection";
import usePageMeta from "../hooks/usePageMeta";
import useScrollToHash from "../hooks/useScrollToHash";

const PATH_TO_SECTION = {
  "/planes": "planes",
  "/packs": "packs",
};

const ServicesHubPage = () => {
  usePageMeta({
    title: "Servicios | RGST",
    description:
      "Servicios técnicos, packs, planes y trabajos realizados para PC, notebooks y consolas.",
    canonical: "https://rgserviciotecnico.com/servicios",
  });

  useScrollToHash({ defaultId: "servicios", pathMap: PATH_TO_SECTION });

  return (
    <PageLayout className="bg-background">
      <ServicesSection />
      <PacksSection />
      <div className="mb-24">
        <PlansSection />
      </div>
    </PageLayout>
  );
};

export default ServicesHubPage;
